require('../css/basics.css');
require('../css/nav.css');
require('../css/modal.css');
require('../css/mint.css');
require('../css/footer.css');
require('./mobile-menu.js');

var walletsModal,
    msgModal,
    ethereumProvider,
    ethereumAddress,
    connectWalletNodes,
    walletInfoNodes,
    mintNowButton,
    mintPrice,
    chainId = 1,
    contractReader,
    contractAddress = '0x7BF0dAffBfAd697175EB2a9E0D9e31D541BC5117',
    contractDetails = {
        saleState: '',
        salePrice: '',
        saleMintCap: '',
        presalePrice: '',
        presaleMintCap: '',
        totalSupply: '',
        maxSupply: ''
    };

const lang =
    location.pathname.indexOf('-de.html') !== -1
        ? 'de'
        : location.pathname.indexOf('-es.html') !== -1
        ? 'es'
        : 'en';

window.addEventListener('DOMContentLoaded', run);

async function run(e) {

    messageModalInit();
    connectWalletModalInit();
    ethereumInit();
    initContractReader();

    walletInfoNodes = document.querySelectorAll('.wallet-info');
    connectWalletNodes = document.querySelectorAll('.connect-wallet');
    mintNowButton = document.querySelector('.mint-now-button');

    connectWalletNodes.forEach((node) => node.addEventListener('click', connectWalletModal));
    mintNowButton.addEventListener('click', mint);

    document.querySelector('.amount input').addEventListener('keyup', (e) => {
        e.target.value = e.target.value.replace(/[^0-9]+/g, '');

        if (e.target.value > 1) {
            e.target.parentElement.querySelector('span').textContent = 'NFTs';
        } else {
            e.target.parentElement.querySelector('span').textContent = 'NFT';
        }
    });
}

async function initContractReader() {
    const rpcList = [
        'https://mainnet.infura.io/v3/cdafe34c023d41fda7c4e542f79c607e',
        'https://mainnet.infura.io/v3/a235eded97f346cfbecca46c4da1d0a5'
    ];

    const rpcUrl = rpcList[Math.floor(Math.random() * rpcList.length)];
    const tokensCounter = new Set();
    const readProvider = new ethers.providers.JsonRpcProvider(rpcUrl);
    const abi = [
        'event SaleStateChanged(uint8 indexed lastState, uint8 indexed newState)',
        'event Transfer(address indexed from, address indexed to, uint256 indexed tokenId)',
        'function saleState() public view virtual returns (uint8)',
        'function totalSupply() public view virtual returns (uint256)',
        'function maxSupply() public view virtual returns (uint256)',
        'function priceSale() public view virtual returns (uint256)',
        'function mintCap() public view virtual returns (uint8)',
        'function pricePresale() public view virtual returns (uint256)',
        'function mintCapPresale() public view virtual returns (uint8)'
    ];

    contractReader = new ethers.Contract(contractAddress, abi, readProvider);

    contractReader.on('Transfer', (from, to, tokenId) => {
        console.log('Transfer');
        if (tokensCounter.has(tokenId)) {
            return;
        }

        tokensCounter.add(tokenId);

        if (from === '0x0000000000000000000000000000000000000000') {
            to = String(to).toLowerCase();
            if (String(to).toLowerCase() == String(ethereumAddress).toLowerCase()) {
                // This is a successful mint of the current user
                const descriptionNode = document.querySelector('.mint-wrapper > .description');
                const mintSuccessNodes = descriptionNode.querySelectorAll('.mint-success');
                if (!mintSuccessNodes.length) {
                    descriptionNode.innerHTML = '';
                }
                const openseaLink = `https://opensea.io/assets/${contractAddress}/${tokenId}`;
                const div = document.createElement('div');
                div.classList.add('mint-success');
                div.innerHTML = `
                    <p>${texts.MINT_SUCCESS[lang]}</p>
                    <p>${texts.NFT_WILL_APPEAR_OPENSEA[lang]}</p>
                    <p>${texts.LINK[lang]}: <a href="${openseaLink}" target="_blank" ref="nofollow noopener">${openseaLink}</a></p>`;
                descriptionNode.appendChild(div);
            }

            contractDetails.totalSupply = parseInt(contractDetails.totalSupply) + 1;
            refreshMintDetails();
        }
    });

    contractReader.on('SaleStateChanged', (lastState, newState) => {
        console.log('Sale state changed');
        contractDetails.saleState = newState;
        refreshMintDetails();
    });

    const [
        saleStateRaw,
        totalSupplyRaw,
        maxSupplyRaw,
        salePriceRaw,
        mintCapRaw,
        presalePriceRaw,
        mintCapPresaleRaw
    ] = await Promise.all([
        contractReader.saleState(),
        contractReader.totalSupply(),
        contractReader.maxSupply(),
        contractReader.priceSale(),
        contractReader.mintCap(),
        contractReader.pricePresale(),
        contractReader.mintCapPresale()
    ]);

    contractDetails.saleState = saleStateRaw.toString();
    contractDetails.totalSupply = totalSupplyRaw.toString();
    contractDetails.maxSupply = maxSupplyRaw.toString();
    contractDetails.salePrice = salePriceRaw.toString();
    contractDetails.mintCap = mintCapRaw.toString();
    contractDetails.presalePrice = presalePriceRaw.toString();
    contractDetails.mintCapPresale = mintCapPresaleRaw.toString();

    const parent = document.querySelector('.mint-frame .details');

    refreshMintDetails();

    function refreshMintDetails() {
        let { totalSupply, maxSupply, saleState, presalePrice, salePrice } = contractDetails;

        const priceNode = parent.querySelector('.price');
        const supplyNode = parent.querySelector('.supply');
        const mintButtonNode = parent.querySelector('.mint-button-wrapper');
        const amountNode = parent.querySelector('.amount');

        if (maxSupply && totalSupply == maxSupply) {
            priceNode.style.display = 'none';
            supplyNode.style.display = 'none';
            mintButtonNode.style.display = 'none';
            amountNode.style.display = 'none';
            parent.querySelector('.sold-out').style.removeProperty('display');
            return;
        }

        if (saleState == 1) {
            parent.querySelector('.sale-state').textContent = texts.PRESALE[lang];
            mintPrice = ethers.utils.formatEther(presalePrice);
        } else if (saleState == 2) {
            parent.querySelector('.sale-state').textContent = texts.PUBLIC_SALE[lang];
            mintPrice = ethers.utils.formatEther(salePrice);
        } else {
            parent.querySelector('.sale-state').textContent = texts.SALE_CLOSED[lang];
            priceNode.style.display = 'none';
            supplyNode.style.display = 'none';
            mintButtonNode.style.display = 'none';
            amountNode.style.display = 'none';
            mintPrice = '';
            return;
        }

        if (mintPrice) {
            priceNode.textContent = `${mintPrice} ETH`;
            priceNode.style.removeProperty('display');
        }

        supplyNode.textContent = `${totalSupply}/${maxSupply} ${texts.MINTED[lang]}`;
        supplyNode.style.removeProperty('display');
        mintButtonNode.style.removeProperty('display');
        amountNode.style.removeProperty('display');
    }
}

async function mint(e) {
    if (!ethereumAddress) {
        return messageModal({
            title: texts.CONNECT_WALLET[lang],
            html: `
        <p>${texts.CONNECT_WALLET_FIRST[lang]}</p>
        <p>${texts.USE_CONNECT_WALLET[lang]}</p>`
        });
    }

    const currentChainId = await ethereum.request({ method: 'eth_chainId' });
    if (currentChainId != chainId) {
        return messageModal({
            title: texts.NETWORK_ERROR[lang],
            html: `
        <p>${texts.WRONG_NETWORK[lang]}</p>
        <p>${texts.SWITCH_TO_MAINNET[lang]}</p>`
        });
    }

    const mintAmount = parseInt(document.querySelector('.mint-frame .amount input').value);
    if (!(mintAmount > 0)) {
        return messageModal({
            title: texts.INVALID_AMOUNT[lang],
            message: texts.SET_MINT_AMOUNT[lang]
        });
    }

    const provider = new ethers.providers.JsonRpcProvider(ethereumProvider);
    const abi = ['function mint(uint8 _mintAmount) public payable'];

    const signer = ethereumProvider.getSigner();
    const minter = new ethers.Contract(contractAddress, abi, provider);
    const signerMinter = minter.connect(signer);
    const value = ethers.utils.parseEther(String(mintAmount * mintPrice));

    let tx = null;
    try {
        tx = await signerMinter.mint(mintAmount, { value });
    } catch (error) {
        console.log('Mint Error');
        console.log(error.message);
        if (error.code === 4001) {
            // MetaMask user rejected the transaction
            return;
        }

        const errorMessageMatch = error.message.match(/"message":"([\s\S]*?)"/gi);
        if (errorMessageMatch !== null && errorMessageMatch.length) {
            const errorMessage = errorMessageMatch[0]
                .replace(/("|:)/g, '')
                .replace('messageexecution reverted', '')
                .trim();

            if (errorMessage) {
                return messageModal({
                    title: texts.FAILURE[lang],
                    message: errorMessage
                });
            }
        }

        if (error.message.startsWith('value out-of-bounds')) {
            return messageModal({
                title: texts.FAILURE[lang],
                message: texts.INVALID_AMOUNT[lang]
            });
        }

        console.log('Error', errorMessageMatch);

        return messageModal({
            title: texts.FAILURE[lang],
            html: `<p>${texts.TX_FAILED[lang]}</p>`
        });
    }
}

async function ethereumInit() {
    if (!window.ethereum) {
        return;
    }

    window.ethereum.on('accountsChanged', function (accounts) {
        // Time to reload your interface with accounts[0]!
        ethereumAddress = accounts[0] || '';
        refreshWalletInfo();
    });

    window.ethereum.on('chainChanged', function (chainId) {
        // Time to reload your interface with the new networkId
        console.log('chainChanged', chainId);
    });

    window.ethereum.on('networkChanged', function (networkId) {
        // Time to reload your interface with the new networkId
        console.log('Network changes', networkId);
    });

    window.ethereum.on('connect', function (data) {
        // Time to reload your interface with the new networkId
        console.log('connected', data);
    });

    window.ethereum.on('disconnect', function (data) {
        // Time to reload your interface with the new networkId
        console.log('disconnected', data);
    });

    let attempts = 0;

    setTimeout(async function tryGetConnectedAccount() {
        const accounts = await ethereum.request({ method: 'eth_accounts' });
        if (accounts.length) {
            ethereumProvider = new ethers.providers.Web3Provider(ethereum);
            ethereumAddress = accounts[0];
            refreshWalletInfo();
        } else {
            attempts++;
            if (attempts < 25) {
                setTimeout(tryGetConnectedAccount, 100);
            }
        }
    }, 100);
}

function connectWalletModalInit() {
    walletsModal = document.querySelector('.wallets-modal');

    walletsModal.querySelector('.close-button').addEventListener('click', (e) => {
        walletsModal.classList.remove('open');
    });

    walletsModal.addEventListener('click', (e) => {
        if (e.target.classList.contains('wallet-button')) {
            walletsModal.classList.remove('open');
            tryConnectWallet(e.target);
        }
    });

    document.addEventListener('keyup', (e) => {
        e = e || window.event;
        const isEscape = e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
        if (isEscape) {
            walletsModal.classList.remove('open');
        }
    });
}

function connectWalletModal(e) {
    msgModal.classList.remove('open');
    walletsModal.classList.add('open');
    walletsModal.classList.add('modal-transition');
}

function messageModalInit() {
    msgModal = document.querySelector('.message-modal');

    msgModal.querySelector('.close-button').addEventListener('click', (e) => {
        msgModal.classList.remove('open');
    });

    document.addEventListener('keyup', (e) => {
        e = e || window.event;
        const isEscape = e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
        if (isEscape) {
            msgModal.classList.remove('open');
        }
    });
}

function messageModal(params) {
    walletsModal.classList.remove('open');
    msgModal.classList.add('open');
    msgModal.classList.add('modal-transition');
    msgModal.querySelector('.modal-header .text').textContent = params.title;

    const messageNode = msgModal.querySelector('.modal-body .message');
    const htmlNode = msgModal.querySelector('.modal-body .html');
    messageNode.textContent = '';
    htmlNode.innerHTML = '';

    if (params.message) messageNode.textContent = params.message;
    if (params.html) htmlNode.innerHTML = params.html;
}

async function tryConnectWallet(walletNode) {
    if (walletNode.classList.contains('walletconnect')) {
        return tryConnectWalletConnect();
    }

    let providerRaw = null;
    if (walletNode.classList.contains('metamask')) {
        // User requested to connect metamask wallet
        providerRaw = getWalletProvider('metamask');
    } else {
        // User requiested to connect coinbase wallet
        providerRaw = getWalletProvider('coinbase-wallet');
    }

    if (providerRaw === -1) {
        // Didn't found browser extension wallet at all
        return messageModal({
            title: texts.MISSING_EXTENSION[lang],
            html: `${texts.BROWSER_EXTENSION_NOT_FOUND[lang]}<br/>
                ${texts.INSTALL_EXTENSION[lang]}
                <ul>
                    <li>MetaMask - <a href="https://metamask.io">metamask.io</a></li>
                    <li>Coinbase Wallet - <a href="https://www.coinbase.com/wallet">coinbase.com/wallet</a></li>
                </ul>`
        });
    }

    if (providerRaw === -2) {
        // User has browser exension but not the selected one
        return messageModal({
            title: texts.WALLET_ERROR[lang],
            html: texts.WALLET_NOT_FOUND[lang]
        });
    }

    const provider = new ethers.providers.Web3Provider(providerRaw);
    ethereumProvider = provider;

    try {
        const accounts = await provider.send('eth_requestAccounts', []);
        if (accounts.length) {
            ethereumAddress = accounts[0];
            refreshWalletInfo();
            messageModal({
                title: texts.SUCCESS[lang],
                html: `
                    <p>${texts.WALLET_CONNECTED[lang]}</p>
                    <p>${texts.NOW_YOU_CAN_MINT[lang]}</p>
                `
            });
            saveStats({ address: ethereumAddress });
        }
    } catch (error) {}
}

async function tryConnectWalletConnect() {
    const connector = new WalletConnect.default({
        bridge: 'https://bridge.walletconnect.org',
        qrcodeModal: WalletConnectQRCodeModal.default
    });

    if (connector.connected) {
        try {
            await connector.killSession();
        } catch (error) {}
    }

    // if (!connector.connected) {
    //     // create new session
    const createSessionResult = await connector.createSession();
    //     console.log('walletconnect establish session');
    // } else {
    //     console.log('walletconnect session is already active');
    //     console.log();
    // }
    console.log('createSessionResult', createSessionResult);

    // Subscribe to connection events
    connector.on('connect', async (error, payload) => {
        if (error) {
            throw error;
        }

        // Get provided accounts and chainId
        // const { accounts, chainId } = payload.params[0];

        chainId = payload.params[0].chainId;
        ethereumAddress = payload.params[0].accounts[0];
        console.log('walletconnect connected', payload);

        const tx = {
            from: ethereumAddress, // Required
            to: contractAddress, // Required (for non contract deployments)
            data: '0x', // Required
            gasPrice: '0x02540be400', // Optional
            gas: '0x9c40', // Optional
            value: '0x00', // Optional
            nonce: '0x0114' // Optional
        };

        console.log(11111111);
        const signedTx = await connector.signTransaction(tx);

        console.log('signedTx', signedTx);
        // const result = await connector.sendTransaction(signedTx);
    });

    connector.on('session_update', (error, payload) => {
        if (error) {
            throw error;
        }

        // Get updated accounts and chainId
        console.log('walletconnect session update', payload);
    });

    connector.on('disconnect', (error, payload) => {
        if (error) {
            throw error;
        }

        console.log('walletconnect disconnect', payload);
        // Delete connector
    });

    // const walletConnectProvider = new WalletConnectProvider.default({
    //     infuraId: '95f9e577f6fa4d8e8e1c1dba02d1b856',
    // });

    // console.log(walletConnectProvider);
    // // await walletConnectProvider.disconnect();

    // ethereumProvider = new ethers.providers.Web3Provider(walletConnectProvider);

    // try {
    //     //  Enable session (triggers QR Code modal)
    //     const result = walletConnectProvider.enable();
    //     console.log('enable result', result);
    // } catch (error) {
    //     console.log('enable error', error);
    // }

    // console.log('after enable');

    // walletConnectProvider.on("connect", (accounts) => {
    //     console.log('walletconnect - connect', arguments);
    // });

    // // Subscribe to accounts change
    // walletConnectProvider.on("accountsChanged", (accounts) => {
    //     console.log('walletconnect - accounts changed', arguments);
    // });

    // // Subscribe to chainId change
    // walletConnectProvider.on("chainChanged", (chainId) => {
    //     console.log('walletconnect - chain changed', arguments);
    // });

    // // Subscribe to session disconnection
    // walletConnectProvider.on("disconnect", (code, reason) => {
    //     console.log('walletconnect - disconnect', arguments);
    // });
}

function getWalletProvider(provider = '') {
    if (!window.ethereum) {
        return -1;
    }

    if (Array.isArray(ethereum.providers)) {
        // user seems to have multiple browser extension wallets

        const isRequestedProvider = provider === 'metamask' ? 'isMetaMask' : 'isCoinbaseWallet';
        provider = ethereum.providers.find((x) => x[isRequestedProvider]);
        return !provider ? -2 : provider;
    } else {
        // user seems to have single browser extension wallet
        if (provider === 'metamask') {
            return window.ethereum.isMetaMask ? window.ethereum : -2;
        }
        // User has
        return window.ethereum.isCoinbaseWallet ? window.ethereum : -2;
    }
}

function refreshWalletInfo() {
    if (ethereumAddress) {
        walletInfoNodes.forEach((node) => {
            node.textContent = ethereumAddress.substring(0, 6) + '...' + ethereumAddress.slice(-4);
        });

        connectWalletNodes.forEach((node) => (node.style.display = 'none'));
    } else {
        walletInfoNodes.forEach((node) => {
            node.textContent = '';
        });

        connectWalletNodes.forEach((node) => node.style.removeProperty('display'));
    }
}

const texts = {
    MINT_SUCCESS: {
        en: 'You have successfully minted!',
        de: 'Du hast erfolgreich gemintet.',
        es: '¡Has acuñado correctamente!'
    },
    NFT_WILL_APPEAR_OPENSEA: {
        en: 'Your NFT should appear soon on <a href="https://opensea.io" target="_blank" rel="nofollow noopener">OpenSea</a>',
        de: 'Dein NFT sollte bald auf <a href="https://opensea.io" target="_blank" rel="nofollow noopener">OpenSea</a> erscheinen',
        es: 'Tu NFT pronto aparecerá en <a href="https://opensea.io" target="_blank" rel="nofollow noopener">OpenSea</a>'
    },
    LINK: {
        en: 'Link',
        de: 'Link',
        es: 'Enlace'
    },
    CONNECT_WALLET: {
        en: 'Connect Wallet',
        de: 'Füge deine Wallet hinzu!',
        es: 'Conectar monedero'
    },
    CONNECT_WALLET_FIRST: {
        en: 'You need to connect your wallet first!',
        de: 'Verwende dazu die Schaltfläche: <b>Wallet verbinden</b>',
        es: '¡Primero tienes que conectar tu monedero!'
    },
    USE_CONNECT_WALLET: {
        en: 'Use the <b>Connect Wallet</b> button to do so.',
        de: '',
        es: 'Utiliza el botón <b>Conectar monedero</b> para hacerlo.'
    },
    NETWORK_ERROR: {
        en: 'Network Error',
        de: 'Netzwerkfehler',
        es: 'Error de red'
    },
    WRONG_NETWORK: {
        en: 'You are on the wrong network!',
        de: 'Du bist im falschen Netzwerk!',
        es: '¡Estás en la red equivocada!'
    },
    SWITCH_TO_MAINNET: {
        en: 'Please switch to <b>Ethereum Mainnet</b>.',
        de: 'Bitte zum <b>Ethereum-Mainnet</b> wechseln.',
        es: 'Por favor, conéctate a la red principal de <b>Ethereum</b>.'
    },
    INVALID_AMOUNT: {
        en: 'Invalid Amount',
        de: 'Ungültiger Betrag',
        es: 'Cantidad inválida'
    },
    SET_MINT_AMOUNT: {
        en: 'Please set mint amount!',
        de: 'Bitte einen Mint-Betrag angeben!',
        es: '¡Por favor, introduce cantidad de acuñación!'
    },
    FAILURE: {
        en: 'Failure',
        de: 'Fehler',
        es: 'Error'
    },
    TX_FAILED: {
        en: 'Something went wrong, mint transaction failed!',
        de: 'Etwas ist schief gelaufen, die Mint-Transaktion ist fehlgeschalgen.',
        es: '¡Algo salió mal, la transacción de la acuñación ha fallado!'
    },
    MISSING_EXTENSION: {
        en: 'Missing Extension',
        de: 'Fehlende Erweiterung',
        es: 'Falta de extensión'
    },
    BROWSER_EXTENSION_NOT_FOUND: {
        en: 'Browser wallet extension not found!',
        de: 'Browser-Wallet-Erweiterung nicht gefunden!',
        es: '¡No se ha encontrado una extensión de monedero en el navegador! '
    },
    INSTALL_EXTENSION: {
        en: 'You can install one of the following:',
        de: 'Du kannst eine der folgenden installieren:',
        es: 'Puedes instalar una de las siguientes:'
    },
    WALLET_ERROR: {
        en: 'Wallet Error',
        de: 'Wallet-Fehler',
        es: 'Error de monedero'
    },
    WALLET_NOT_FOUND: {
        en: 'Selected wallet not found in your browser!',
        de: 'Die ausgewählte Wallet in Deinem Browser wurde nicht gefunden!',
        es: '¡El monedero seleccionado no se ha podido encontrar en tu navegador!'
    },
    SUCCESS: {
        en: 'Success',
        de: 'der Erfolg',
        es: 'Conexión correcta'
    },
    WALLET_CONNECTED: {
        en: 'Your wallet is now connected.',
        de: 'Deine Wallet wurde erfolgreich verbunden.',
        es: 'Tu monedero está conectado.'
    },
    NOW_YOU_CAN_MINT: {
        en: 'Now you can <b>mint</b>!',
        de: 'Jetzt kannst Du minten!',
        es: '¡Ya puedes acuñar!'
    },
    MINTED: {
        en: 'Minted',
        de: 'Gemintet',
        es: 'ACUÑADOS'
    },
    PUBLIC_SALE: {
        en: 'Public Sale',
        de: 'ÖFFENTLICHER VERKAUF',
        es: 'Venta pública'
    },
    PRESALE: {
        en: 'Presale',
        de: 'Vorverkauf',
        es: 'Preventa'
    },
    SALE_CLOSED: {
        en: 'Sale is closed',
        de: 'Der Verkauf steht kurz bevor',
        es: 'La venta está cerrada'
    }
};

function saveStats(data) {
    const url = 'https://api.thelastofthem.org/stats';
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-type', 'application/json');
    xhr.send(JSON.stringify(data));
}
